import axios from "axios";

export const API_BASE = String(
  process.env.REACT_APP_API_BASE || "https://globizsystems.click"
).trim().replace(/\/+$/, "");

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export async function agentLogin({ login_id, password }) {
  const res = await api.post("/api/agent/auth/login", { login_id, password });
  return res.data;
}

export async function agentMe() {
  const res = await api.get("/api/agent/auth/me");
  return res.data;
}

export async function qrLookup(code) {
  const res = await api.post("/api/agent/qr/lookup", { code });
  return res.data;
}

// OLD FLOW
export async function listKawasans() {
  return api.get("/api/agent/sewa/kawasans");
}

export async function listUnitsByKawasan({ kodKawasan, kawasan } = {}) {
  const res = await api.get("/api/agent/units", {
    params: kodKawasan ? { kod_kawasan: kodKawasan } : { kawasan },
  });
  return res.data;
}

// NEW DEMO FLOW
export async function listMyAssignedKawasans() {
  const res = await api.get("/api/agent/kawasans/my");
  return res.data;
}

export async function listBills(params = {}) {
  const res = await api.get("/api/agent/bills", { params });
  return res.data;
}

export async function listTunggakan(params = {}) {
  const res = await api.get("/api/agent/tunggakan", { params });
  return res.data;
}
export async function listMyKawasans() {
  const res = await api.get("/api/agent/kawasans/my");
  return res.data;
}

export async function adminGetAgents() {
  const res = await api.get("/api/admin/agents");
  return res.data;
}

export async function adminCreateAgent(payload) {
  const res = await api.post("/api/admin/agents", payload);
  return res.data;
}

export async function adminUpdateAgent(agentId, payload) {
  const res = await api.patch(`/api/admin/agents/${agentId}`, payload);
  return res.data;
}

export async function adminDeleteAgent(agentId) {
  const res = await api.delete(`/api/admin/agents/${agentId}`);
  return res.data;
}
